import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { EventStatusEnum, EventSummaryDto } from '@aoe/client';
import { Store } from '@ngrx/store';
import { DialogService } from '../core/services/dialog.service';
import { eventActions } from '../core/store/event/event.actions';
import { selectEventList, selectEventLoading } from '../core/store/event/event.selector';

@Component({
  selector: 'aoe-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {

  private events!: Array<EventSummaryDto>;
  private readonly subcriptions = new Subscription();

  public isLoading = false;


  constructor(
    private readonly store: Store,
    private readonly dialogService: DialogService
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(eventActions['loadEvent']({ payload: {} }));
    this.subcriptions.add(this.store.select(selectEventList).subscribe(res => this.events = res));
    this.subcriptions.add(this.store.select(selectEventLoading).subscribe(res => this.isLoading = res));
  };

  ngOnDestroy(): void {
    this.subcriptions.unsubscribe();
  }

  get eventsInProgress(): Array<EventSummaryDto> {
    return this.events?.filter(e => e.timingStatus === EventStatusEnum.IN_PROGRESS);
  }

  get eventsResults(): Array<EventSummaryDto> {
    return this.events?.filter(e => e.timingStatus === EventStatusEnum.FINISHED);
  }

  get eventsSoon(): Array<EventSummaryDto> {
    return this.events?.filter(e => e.timingStatus === EventStatusEnum.NOT_STARTED);
  }

  get nbEventAvailable() {
    return this.events.length;
  }

  openMap(): void {
    this.dialogService.openEventMap(this.eventsSoon);
  }
}
